// на момент написания (02.04.2025) отличается от ai-dictionary-virtual-grid.vue только // свойством
selectionMode='multiple' (в оригинальном компоненте - 'single') // а также изменённой функцией toolbarButtonClick
<template>
    <ai-grid-virtual-base
        ref="gridInstance"
        :meta="meta"
        selectionMode="multiple"
        :customContextMenu="customContextMenu"
        :to-remove-toolbar-items-names="toRemoveToolbarItemsNames"
        :current-value="currentValue"
        :auto-load-data="meta.autoLoadData || false"
        @toolbar-button-click="toolbarButtonClick"
    />
</template>
<script setup>
import AiGridVirtualBase from '@/components/ai-grid-virtual/ai-grid-virtual-base.vue';
import { ref } from 'vue';

const props = defineProps({
    meta: {
        type: Object,
        default: () => ({ columns: [] }),
    },
    rowClickCallBack: {
        type: Function,
        default: () => {},
    },
    currentValue: {
        type: String,
    },
});
const emit = defineEmits(['dictionarySelectionChanged']);
const customContextMenu = [{ name: 'gotoCard', visible: false }];
const toRemoveToolbarItemsNames = ['copy', 'edit', 'add', 'delete', 'save'];
const gridInstance = ref();

// изменённая функция
const toolbarButtonClick = event => {
    if (event.item.component.name === 'choice') {
        const selectedRowKeys = gridInstance.value.gridInstance.option('selectedRowKeys');

        const dataSource = gridInstance.value.gridInstance.option('dataSource').items();
        const rowsData = [];
        for (let i = 0; i < selectedRowKeys.length; i++) {
            rowsData.push(dataSource.find(row => row[props.meta.keyExpr] === selectedRowKeys[i]));
        }

        emit('dictionarySelectionChanged', rowsData);
    }
};
defineExpose({
    gridInstance,
});
</script>
